import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/image/logoBlancoSinFondo.png";

const Footer = () => {
  const [iconSize, setIconSize] = useState("lg");

  useEffect(() => {
    const handleResize = () => {
      setIconSize(window.innerWidth < 640 ? "lg" : "2x");
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const socialLinks = [
    {
      href: "https://www.facebook.com/tortoneautomotores?mibextid=ZbWKwL",
      icon: faFacebook,
      color: "from-blue-600 to-blue-700",
      hoverColor: "hover:shadow-blue-500/30",
      name: "Facebook"
    },
    {
      href: "https://www.tiktok.com/@tortone.automotor?_t=8mK0pEem93e&_r=1",
      icon: faTiktok,
      color: "from-gray-700 to-gray-900",
      hoverColor: "hover:shadow-gray-500/30",
      name: "TikTok"
    },
    {
      href: "https://www.instagram.com/tortoneautomotoresautos?igsh=YmJucWprcm5vZWU5",
      icon: faInstagram,
      color: "from-pink-500 to-orange-500",
      hoverColor: "hover:shadow-pink-500/30",
      name: "Instagram"
    },
    {
      href: "https://walink.co/f717a6",
      icon: faWhatsapp,
      color: "from-green-500 to-green-600",
      hoverColor: "hover:shadow-green-500/30",
      name: "WhatsApp"
    }
  ];

  return (
    <footer className="relative bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 text-gray-100 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative z-10 py-8 px-2 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center max-w-7xl mx-auto">
          
          {/* Map Section - Hidden on mobile, visible on desktop */}
          <div className="hidden lg:flex justify-start">
            <div className="relative group ml-0">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 rounded-2xl opacity-20 blur-sm group-hover:opacity-30 transition-opacity duration-300"></div>
              <iframe
                title="Google Maps Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3272.1579742447534!2d-57.96461169999999!3d-34.9024849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a2e7ad9e0f0303%3A0xd1e7a4cd9918a4da!2sC.%2035%20566%2C%20B1902BBX%20La%20Plata%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1713816509441!5m2!1ses!2sar"
                width="380"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="relative z-10 rounded-2xl shadow-xl border border-gray-600"
              />
            </div>
          </div>

          {/* Logo Section */}
          <div className="text-center">
            <a
              onClick={() => (window.location.href = "/")}
              className="block mx-auto cursor-pointer group"
            >
              <div className="relative inline-block">
                <div className="absolute inset-0 bg-gradient-to-r from-gray-500 to-gray-700 rounded-full opacity-0 group-hover:opacity-15 blur-xl transition-opacity duration-300"></div>
                <img
                  src={logo}
                  alt="Logo"
                  className="relative mx-auto h-32 w-auto sm:h-40 object-contain transform group-hover:scale-105 transition-transform duration-300 drop-shadow-2xl"
                  style={{ maxWidth: '200px' }}
                />
              </div>
            </a>
          </div>

          {/* Social Media Section */}
          <div className="text-center">
            <div className="mb-8">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-200 mb-4">
                Seguinos en nuestras redes
              </h3>
              <div className="w-16 h-1 bg-gradient-to-r from-gray-500 to-gray-700 mx-auto rounded-full"></div>
            </div>
            
            <div className="flex justify-center">
              <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-4 w-fit">
                {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  className="group relative"
                  title={social.name}
                >
                  <div className={`w-14 h-14 bg-gradient-to-r ${social.color} rounded-full flex items-center justify-center shadow-lg ${social.hoverColor} hover:shadow-xl transform hover:scale-110 hover:-translate-y-1 transition-all duration-300 border border-gray-600`}>
                    <FontAwesomeIcon 
                      icon={social.icon} 
                      className="text-white text-3xl"
                    />
                  </div>
                  
                  {/* Tooltip */}
                  <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-800 text-gray-200 px-3 py-1 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap border border-gray-600">
                    {social.name}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                  </div>
                </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-600">
          <p className="text-center text-sm sm:text-base text-gray-300">
            &copy; {new Date().getFullYear()} Tortone Automotores. Powered by{" "}
            <a
              href="http://www.gcarreiras.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-200 hover:text-white font-semibold transition-colors duration-300 hover:underline"
            >
              gcarreiras
            </a>
            .
          </p>
        </div>
      </div>
      
      {/* Decorative bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-gray-600 via-gray-700 to-gray-800"></div>
    </footer>
  );
};

export default Footer;